import React from 'react';
import Form from 'components/form';
import { Container } from 'routes/surface/components/node-modal-form/components/background-node-modal/components/document-node-form/components/upload-file-form/style';
import {
  FileInputSmall,
  Header,
  NameTextInput,
  ImageList,
  ImageListItem,
  StyledImage,
} from 'routes/surface/components/node-modal-form/style';
import { UploadFormWrapper } from 'routes/surface/components/node-modal-form/components/background-node-modal/components/document-node-form/components/upload-file-form/style';
import { useTranslation } from 'i18n';
import { mixed, object, string } from 'yup';

import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@material-ui/core/IconButton';
// import  from '@mui/icons-material/Info';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useQuery } from '@apollo/client';
import { backgroundTemplatesQuery } from 'graphql/admin/backgrounds';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from 'styled-components';
export interface UploadFileFormProps {
  accept?: string[];
  onFileChange: Function;
  onNameChange: Function;
  onCancel: Function;
  onSubmit: any;
}

const defaultProps = {
  accept: ['jpg', 'jpeg', 'png', 'pdf'],
};

function createValidationSchema(t) {
  return function () {
    return object().shape({
      //  name: string().required(t('name is required')),
      file: mixed().required(t('file is required')),
    });
  };
}

// const itemData = [

//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Rufzeichen_rot.png',
//     title: 'Rufzeichen Rot',
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Pro_Contra.png',
//     title:'Pro und Contra',
//     description: "1) Erstellen Sie Elemente als Argumente FüR oder GEGEN eine Maßfnahme.\n(2) Ziehen Sie diese in den jeweiligen Bereich\n    (3) Teilen Sie die Zelle um die Meinung aller zur Umsetzung notwenigen Personen zu sammeln "
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Plan_A_Plan_B_Plan_C.png',
//     title:'Plan A,  Plan B,  Plan C',
//     description: "Ziehen Sie Elemente als Argumente für einen Plan (=Varainte) in den jeweiligen Bereich."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_CortLex_1.jpg',
//     title: 'Design Cortlex 1',
//     description: "Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_CortLex_2.jpg',
//     title: 'Design Cortlex 2',
//     description: "Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_CortLex_3.png',
//     title: 'Design Cortlex 3',
//     description: "Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_Cortlex_4.png',
//     title: 'Design Cortlex 4',
//     description: "Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Design_CortLex_5.png',
//     title: 'Design Cortlex 5',
//     description: "Fügen Sie diesen Hintergrund hinzu um einen Bereich für bestimmte Elemente zu markieren."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Fokus.png',
//     title:'Fokus',
//     description: "Die wichtigsten Elemente sammeln Sie hier in der Mitte, die weniger wichtigen eher am Rand."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/My_TO_Dos.png',
//     title:'Todos',
//     description: "Erstellen Sie Post-Ist mit Ihren TO DOs und ziehen Sie diese in die Zeilen."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Ga_steliste.png',
//     title:'Gästelist',
//     description: "Fügen Sie die Namen der Gästeste als Textfeld hinzu und ziehen Sie diese in den Bereich Zusage, offen oder Absage.\nTeilen Sie die Zelle mit allen anderen Beteiligten!"
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Kalender_2022.png',
//     title:' Kalender',
//     description: "Fügen sie den Kalender 2022 hinzu und positionieren Sie die Elemente an der passenden Stelle."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Decision-Matrix.png',
//     title:'Decision Matrix',
//     description: "Halten Sie eine neue Aufgaben auf einem Post-It fest und ziehen Sie diese je nach Wichtigkeit und Dringlichkeit in den entsprechenden Bereich. So arbeiten Sie effektiver und effizienter."
//   },

//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Siegertreppchen.png',
//     title:'Siegertreppchen',
//     description: "Fügen Sie dieses Siegertreppchen hinzu um die Top 3 von mehreren möglichen Entscheidung optisch hervorgehoben darzustellen."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Next_Steps.png',
//     title:'Next Steps',
//     description: "(1) Erstellen Sie zunächst Post-Its mit den nächsten Schritten.\n(2) Laden Sie Bilder von den Personen hoch, denen Sie Aufgaben zuweisen möchten.\nAlternativ können Sie auch Textfelder mit den Namen erstellen.\n(3) Teilen Sie die Zelle mit denjenigen Personen."
//   },
//   {
//     img: 'https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Rufzeichen_rot.png',
//     title: 'Rufzeichen Rot',
//     description: "Fügen Sie dieses Rufzeichen hinzu um einen besonders wichtigen Bereich zu markieren."
//   },

// https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/Fokus.png
// https://s3.eu-central-1.amazonaws.com/co.9y.cortlex.node-files/My_TO_Dos.png
// Ga_steliste.png

// Decision-Matrix.png
// Pro_Contra.png

// {
//   img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
//   title: 'Breakfast',
// },
// {
//   img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
//   title: 'Burger',
//   description: 'Short Description',
// },
// {
//   img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
//   title: 'Camera',
//   description:
//     'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut sem volutpat, elementum diam eget, maximus velit. Nunc vehicula ante ipsum, eu sodales nibh luctus vel. Pellentesque at dui sed metus blandit molestie ut imperdiet est. Maecenas ultricies nulla a orci mattis, nec vehicula sapien efficitur.',
// },
// {
//   img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
//   title: 'Coffee',
// },
// {
//   img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
//   title: 'Hats',
// },
// {
//   img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
//   title: 'Honey',
// },
// {
//   img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',
//   title: 'Basketball',
// },
// {
//   img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',
//   title: 'Fern',
// },
// {
//   img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',
//   title: 'Mushrooms',
// },
// {
//   img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
//   title: 'Tomato basil',
// },
// {
//   img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',
//   title: 'Sea star',
// },
// {
//   img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
//   title: 'Bike',
// },
// {
//   img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
//   title: 'Breakfast',
// },
// {
//   img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
//   title: 'Burger',
// },
// {
//   img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
//   title: 'Camera',
// },
// {
//   img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
//   title: 'Coffee',
// },
// {
//   img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
//   title: 'Hats',
// },
// {
//   img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
//   title: 'Honey',
// },
// {
//   img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',
//   title: 'Basketball',
// },
// {
//   img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',
//   title: 'Fern',
// },
// {
//   img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',
//   title: 'Mushrooms',
// },
// {
//   img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
//   title: 'Tomato basil',
// },
// {
//   img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',
//   title: 'Sea star',
// },
// {
//   img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
//   title: 'Bike',
// },
// ];

function UploadFileForm(props: UploadFileFormProps) {
  const { t } = useTranslation();

  const validationSchema = React.useMemo(createValidationSchema(t), []);
  const [selection, setSelection] = React.useState<number | null>(null);

  const { data, loading, error } = useQuery(backgroundTemplatesQuery, {
    // skip: isLoginOrRegisterPage,
    fetchPolicy: 'network-only',
  });

  const list = [{}, ...(data?.backgrounds?.nodes || [])];
  console.log('XXX', data);
  return (
    <Form
      initialValues={{ file: null }}
      validationSchema={validationSchema}
      onSubmit={props.onSubmit}>
      {(form) => (
        <Container>
          <Header>
            <Form.Button
              label={t('Close')}
              onClick={props.onCancel}
              secondary
            />
            <Form.SubmitButton
              label={t('Hintergrund einfügen')}
              onClick={form.handleSubmit}
            />
          </Header>
          <UploadFormWrapper>
            <ImageList
              sx={{ width: 550, height: 600 }}
              cols={4}
              rowHeight={200}>
              {list.map((item, index) => {
                return (
                  <ImageListItem key={item.img}>
                    {index !== 0 && (
                      <>
                        {/*     {index == selection &&
            <div>SELECTED</div>} */}

                        <StyledImage
                          selected={index == selection}
                          src={`${item.url}`}
                          srcSet={`${item.url}`}
                          alt={item.title}
                          loading="lazy"
                          onClick={() => {
                            console.log('XXX', index);
                            if (index == selection) {
                              setSelection(null);
                              props.onFileChange(null);
                              form.setFieldValue('file', null);
                            } else {
                              form.setFieldValue('file', {
                                type: 'jpg',
                                ...list[index],
                              });
                              setSelection(index);
                              props.onFileChange({
                                type: 'jpg',
                                ...list[index],
                              });
                            }
                          }}></StyledImage>
                        <ImageListItemBar
                          title={item.title}
                          actionPosition="right"
                          actionIcon={
                            item.description && (
                              <Tooltip
                                title={item.description}
                                arrow
                                placement="top">
                                <IconButton
                                  sx={{ color: 'white' }}
                                  aria-label={`star ${item.title}`}
                                  onClick={() => {}}>
                                  <InfoIcon style={{ color: 'white' }} />
                                </IconButton>
                              </Tooltip>
                            )
                          }
                        />
                      </>
                    )}

                    {index === 0 && (
                      <FileInputSmall
                        name="file"
                        onChange={props.onFileChange}
                        label={t('Select or drag {{types}} file', {
                          replace: { types: props.accept?.join(', ') },
                        })}
                        $hasFile={form.values.file}
                        accept={props.accept}
                      />
                    )}
                  </ImageListItem>
                );
              })}
            </ImageList>
          </UploadFormWrapper>
        </Container>
      )}
    </Form>
  );
}

UploadFileForm.defaultProps = defaultProps;

// export default UploadFileForm;

function Themed(props) {
  const themeStyled = useTheme();
  const theme = createTheme({
    // palette: {
    //   type: 'light',
    //   primary: {
    //     main: '#FFE736',
    //   },
    //   secondary: {
    //     main: '#f50057',
    //   },
    //   text: {
    //     primary: '#ffffff',
    //   },
    // },
  });
  return (
    <ThemeProvider theme={{ ...theme, ...themeStyled }}>
      <UploadFileForm {...props} />
    </ThemeProvider>
  );
}

export default Themed;
